/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:40:59AM]
Permissions to update outside the main branch: [false]
*/

import { getMaskFromPhone, Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { BODatePicker } from 'base-components/BODatePicker/BODatePicker';
import { SmsLogFilter } from 'models/api/smsLog';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

export default function SmsLogsFilter() {
    const { t } = useTranslation();
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<SmsLogFilter>();

    return (
        <>
            <Row>
                <Col md={6}>
                    <BODatePicker
                        id="ds-start-date"
                        value={draftFilter.sd}
                        onChange={(date) => {
                            setDraftFilter((x) => ({ ...x, sd: date }));
                        }}
                        inputProps={{ label: t('BackOfficeDtFrom') }}
                    />
                </Col>

                <Col md={6}>
                    <BODatePicker
                        id="ds-end-date"
                        value={draftFilter.ed}
                        onChange={(date) => {
                            setDraftFilter((x) => ({ ...x, ed: date }));
                        }}
                        inputProps={{ label: t('BackOfficeTo') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        value={draftFilter.phone}
                        name="phone"
                        label={t('BackOfficePhone')}
                        maskProps={{
                            mask: getMaskFromPhone(draftFilter.phone),
                            onAccept: (value) => {
                                setDraftFilter((prevState) => ({
                                    ...prevState,
                                    phone: value,
                                }));
                            },
                        }}
                    />
                </Col>
            </Row>
        </>
    );
}
